import GitHub from './icons/github';
import Instagram from './icons/instagram';
import LinkedIn from './icons/linkedin';
import Twitter from './icons/twitter';
import { IconsWrapper } from './styled';

const Icons = () => (
  <IconsWrapper>
    <a
      href="https://twitter.com/auth0"
      target="_blank"
      rel="noopener noreferrer"
      aria-label="Twitter"
    >
      <Twitter />
    </a>
    <a
      href="https://linkedin.com/company/auth0"
      target="_blank"
      rel="noopener noreferrer"
      aria-label="LinkedIn"
    >
      <LinkedIn />
    </a>
    <a
      href="https://www.instagram.com/weareauth0"
      target="_blank"
      rel="noopener noreferrer"
      aria-label="Instagram"
    >
      <Instagram />
    </a>
    <a
      href="https://github.com/auth0"
      target="_blank"
      rel="noopener noreferrer"
      aria-label="GitHub"
    >
      <GitHub />
    </a>
  </IconsWrapper>
);

export default Icons;
